import React, { useEffect } from 'react';
import "./index.scss";

import AppTool from '@utils/app-tool';


const ExpectDialog = (props) => {
  useEffect(() => {

  }, []);

  return (
    <div className="cExpectDialog cDialogAttr" onClick={() => { AppTool.closeDialog('.cExpectDialog') }}>
      <div className="cMask"></div>
      <div className="cDialog" >
        <img className="cImage" src={window.assetUrl(`/images/expect-dialog.png`)} />
      </div>
    </div>
  )
}

export default ExpectDialog;